import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, KeepAlive as _KeepAlive, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "v-im"
}

import showUser from "@/components/user-modal/";
import Avatar from "@/components/Avatar.vue";
import { useUserStore } from "@/store/userStore";
import { useChatStore } from "@/store/chatStore";
import AccountApi from "@/api/AccountApi";

import {
  computed,
  getCurrentInstance,
  nextTick,
  onMounted,
  reactive,
  ref,
} from "vue";
import Auth from "@/api/Auth";
import Message from "@/mode/Message";
import ChatType from "@/config/ChatType";
import ChatUtils from "@/utils/ChatUtils";
import vimConfig from "@/config/VimConfig";
import { ElMessageBox } from "element-plus/es";
import { logout } from "@/api/Login";
import router from "@/router";
import { useRoute } from 'vue-router';

export default /*@__PURE__*/_defineComponent({
  __name: 'Home',
  setup(__props) {

const routList = ['/index/chat', '/index/friend', '/index/group', '/index/aiApply']
onMounted(() => {
  const route = useRoute();
  const paramValue = route.path
  menuIndex.value = (routList.indexOf(route.path) + 1 + '')
})

const { proxy } = getCurrentInstance();
const userStore = useUserStore();
const chatStore = useChatStore();
const currentUser = userStore.getUser();
if (!currentUser) {
  AccountApi.toLogin();
}
const userConf = reactive({
  show: false,
  userId: "",
});
const unreadCount = computed(() => {
  let i = 0;
  chatStore.chats.forEach((item) => {
    i = i + item.unreadCount;
  });
  return i;
});
// 菜单缩放
const showgoBtn = ref(true)
const openBarStyle = {
  width: '16.2rem',
}
const openLeftBar = () => {
  showgoBtn.value = false
}
const closeLeftBar = () => {
  showgoBtn.value = true
}
// 点击菜单
const menuIndex = ref('1')
const onmenu = (index: string) => {
  console.log(index)
  menuIndex.value = index
}
const vimLogout = () => {
  ElMessageBox.confirm("确定注销并退出系统吗？", "提示", {
    confirmButtonText: "确定",
    cancelButtonText: "取消",
    type: "warning",
  }).then(() => {
    logout().then(() => {
      proxy.$ws.close();
      AccountApi.toLogin();
    });
  });
};

onMounted(() => {
  if (currentUser) {
    let ips=''
    let wsProtocol=''
    if (Auth.getIp().indexOf("ai.123vp.com") > -1) {
      ips="ai.123vp.com"
      wsProtocol='wss'
    }else if(Auth.getIp().indexOf("114.242.3.137") > -1) {
      ips="114.242.3.137"
      wsProtocol='wss'
    } else{
      ips=Auth.getIp()
      wsProtocol='ws'
    }
    //初始化websocket
    chatStore.reset();
    proxy.$ws.init(
      wsProtocol +
      "://" +
      ips +
      ":" +
      vimConfig.wsPort +
      "?token=" +
      Auth.getToken()
    );
    //重写 onmessage 方法，收到的消息都在这里进行分发
    proxy.$ws.onmessage = (message: Message) => {
      console.log('收到的消息都在这里进行分发')
      console.log(message)
      // 助手信息
      // if(message.type=='A'){
      //   chatStore.pushMessage(message)
      // }
      //群聊里面，自己发的消息不再显示
      if (currentUser.id === message.fromId) {
        message.mine = true;
      } else {
        proxy.$winControl.default.flashIcon();
        proxy.$winControl.default.flashFrame();
      }
      //友聊换chatId,chatId 不一样
      if (
        ChatType.FRIEND === message.type &&
        currentUser.id !== message.fromId
      ) {
        message.chatId = message.fromId;
      }

      chatStore.pushMessage(message);

      nextTick(() => {
        ChatUtils.imageLoad("message-box");
      });
    };
    // // 重写onmessageChangeVoice方法
    // proxy.$ws.重写onmessageChangeVoice方法 = (message: Message) => {
    //   console.log('收到重写onmessageChangeVoice方法')
    //   console.log(message)
      
    // };
    userConf.userId = currentUser.id;
  }
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_unref(currentUser))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_router_view, { class: "content" }, {
          default: _withCtx(({ Component }) => [
            (_openBlock(), _createBlock(_KeepAlive, null, [
              (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
            ], 1024))
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
}
}

})